import React, { useCallback, useMemo, useState } from 'react';

import { IPpdPricesDto } from '@r1-frontend/api-domru/ppd-service/dto/IPpdPricesDto';
import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';

import type { TDispatch } from '~/src/features/center/BlockInfo';
import BlockInfo from '~/src/features/center/BlockInfo';
import BlockPrice from '~/src/features/center/BlockPrice';
import { CATEGORY_IDS, TEXT_BLOCK_PRICE } from '~/src/features/center/constants/data';
import type { TRefObject } from '~/src/features/center/InfoBlocks';
import type { IData } from '~/src/features/center/utils';
import { getBgBlocKPrice, getTextLegal, getTitleForBlocKPrice } from '~/src/features/center/utils';

import * as ST from './styled';

interface IDataSlot {
    slotRefs: TRefObject,
    city: ICurrentCity,
    formProblemRefs: TRefObject,
    blockPriceRefs: TRefObject,
    isHiddenForm: boolean,
    isHiddenPriceBlock: boolean,
    setHideStatusForm: TDispatch,
    setHideStatusPriceBlock: TDispatch,
    data: IData,
    dataPrices: IPpdPricesDto[],
}

const Slot: React.FC<IDataSlot> = ({
    data,
    slotRefs,
    city,
    formProblemRefs,
    isHiddenForm,
    isHiddenPriceBlock,
    setHideStatusForm,
    setHideStatusPriceBlock,
    blockPriceRefs,
    dataPrices,
}) => {

    const [isActiveForm, setActiveForm] = useState(false);
    const [isActivePriceBlock, setActivePriceBlock] = useState(false);
    const onClickHandler = useCallback((_setState, setActive, actionType) => {
        dataLayerPush({ event: EVENTS.UAevent, category: CATEGORIES.paidServices, action: actionType, label: 'null' });
        setActive(true);
        _setState(false);
    }, []);

    const dataPricesFiltered = useMemo(() => {
        const categoryIdsArray = Object.values(CATEGORY_IDS);
        /** Первый блок не имеет компонента выбора услуг с ценами */
        categoryIdsArray.unshift(null);
        return dataPrices.filter((elem) => Number(elem.category) === Object.values(categoryIdsArray)[data.index]);
    }, [dataPrices, data.index]);

    return (
        <ST.Container
            bgGradient={data.bgGradient}
            ref={slotRefs.current[data.index]}
            needShadow={isActivePriceBlock && !isHiddenPriceBlock}
            data-test={'container'}
        >
            {isActivePriceBlock && !isHiddenPriceBlock
                ? <BlockPrice
                    city={city}
                    setActivePriceBlock={setActivePriceBlock}
                    blockPriceRef={blockPriceRefs.current[data.index]}
                    title={getTitleForBlocKPrice()[data.index].title}
                    bgGradientPrice={getBgBlocKPrice()[data.index].bgGradientPrice}
                    text={TEXT_BLOCK_PRICE[data.index]}
                    textBottom={getTextLegal()[data.index]}
                    dataPricesFiltered={dataPricesFiltered}
                    data-test={'block-price'}
                />
                : <BlockInfo
                    data={data}
                    city={city}
                    formProblemRefs={formProblemRefs}
                    isHiddenForm={isHiddenForm}
                    isActiveForm={isActiveForm}
                    onClickHandler={onClickHandler}
                    setHideStatusForm={setHideStatusForm}
                    setHideStatusPriceBlock={setHideStatusPriceBlock}
                    setActiveForm={setActiveForm}
                    setActivePriceBlock={setActivePriceBlock}
                    dataPricesFiltered={dataPricesFiltered}
                    data-test={'block-info'}
                />
            }
        </ST.Container>
    );
};

export default Slot;
